import { render, staticRenderFns } from "./AssignmentRoomImagesModal.vue?vue&type=template&id=4c80d1fa&"
import script from "./AssignmentRoomImagesModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentRoomImagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports